import React from "react"
import PropTypes from 'prop-types'
import { Link, StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout"
import SEO from "../components/seo"


const allProjects = () => (
  <StaticQuery
    query={graphql`
    query allProjectsArchive {
      allMarkdownRemark(filter: {fileAbsolutePath: {regex: "/projects/"  }}){
        edges{
          node{
            frontmatter{
              title
              location
              performance_date
              buyer
              role
              tag
              housing_size
              plot_size
              path
              featuredImage{
                childImageSharp {
                  fluid(maxWidth: 700) {
                    src
                  }
                }
              }
            }
          }
        }
      }
    }
    `}
    render={({allMarkdownRemark}) => (
      <Layout>
        <div className="container is-widescreen content-wrap">
          <section className="section">
          <h1 className="title">Verkefni</h1>
            {allMarkdownRemark.edges.map(edge => (
            <>
              <Link to={`/projects/${edge.node.frontmatter.path}`}>
                <div className="box">
                  <div className="media">
                    <div className="media-left" id="projects">
                      <img className="image-of-project" src={edge.node.frontmatter.featuredImage.childImageSharp.fluid.src} alt="Placeholder image"></img>
                    </div>
                    <div className="media-content">

                      <p className="title is-2" key={edge.node.frontmatter.path}>
                          {edge.node.frontmatter.title}
                      </p> 
                      <p className="subtitle is-5">{edge.node.frontmatter.location}</p>


                      {edge.node.frontmatter.tag.map(oneTag => (
                        <p className="tag is-primary space-tags">{oneTag}</p>
                      ))}

                      <p className="subtitle is-6" id="projects">{edge.node.frontmatter.performance_date} | {edge.node.frontmatter.buyer}</p>
                    </div>
                  </div>
                </div>
              </Link>
              <br></br>
              </>
            ))}
          </section>
        </div>
      </Layout>
    )}
  />
)

export default allProjects
